import React from 'react';
import PropTypes from 'prop-types';
import { ErrorAlert, WarningAlert } from '@nebula/alert';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import useSplits from '../../../hooks/useSplits';
import { splitsList } from '../../../constants';
import { PAYMENT_ERROR_TYPES } from '../../PaymentOrchestrator/constants/paymentErrors';

const PaymentError = ({ error }) => {
  const dispatch = useDispatch();
  const splits = useSplits([splitsList.webNewChangePaymentMethod]);
  const isWebNewChangePaymentMethodEnabled = splits[splitsList.webNewChangePaymentMethod];

  switch (error.type) {
    case PAYMENT_ERROR_TYPES.TOKENIZATION.GENERATING_PAYMENT_TOKEN:
    case PAYMENT_ERROR_TYPES.TOKENIZATION.INITIATING_PURCHASE:
      return (
        <WarningAlert
          title="We could not take your payment"
          message="Please check your card details are correct or try a different method."
          showIcon
        />
      );
    case PAYMENT_ERROR_TYPES.TOKENIZATION.ACTIVATION_FAILED_REFUND_MESSAGE:
      return (
        <WarningAlert
          title="We could not activate your account"
          message="If your payment has been taken, we'll give you a full refund within 5 working days. If no payment was taken, wait 24 hours and try again."
          actionText="Try again"
          actionCallback={() => dispatch(push('/'))}
          showIcon
        />
      );
    case PAYMENT_ERROR_TYPES.AUTHORIZATION.UNSUCCESSFUL_3DS:
    case PAYMENT_ERROR_TYPES.AUTHORIZATION.UNSUCCESSFUL_PURCHASE_RETRY:
      return (
        <WarningAlert
          title="We could not upgrade your account"
          message="You have not been charged. Please try again."
          showIcon
        />
      );
    case PAYMENT_ERROR_TYPES.FULFILLMENT.INITIATING_FULFILLMENT:
      return (
        <ErrorAlert
          title="We could not upgrade your account"
          message="You have not been charged. Please try again later or contact us for support."
          showIcon
        />
      );
    case PAYMENT_ERROR_TYPES.METHOD_CHANGE.UNSUCCESSFUL:
      return isWebNewChangePaymentMethodEnabled ? (
        <ErrorAlert
          title="We could not change your payment details"
          message="Please check your card details are correct or try a different method."
          showIcon
        />
      ) : (
        <WarningAlert
          title="We could not change your payment details"
          message="Please check your card details are correct or try a different method."
          showIcon
        />
      );
    default:
      return null;
  }
};

PaymentError.propTypes = {
  error: PropTypes.shape({
    type: PropTypes.string.isRequired,
  }).isRequired,
};

export default PaymentError;
